/**
 * Pronto Posto – Maildaten · Englisch (en-GB / EN-UK) · KS04
 *
 * KS04 Flug – Lady Luna / Maxwell Lang. Postfach: maxwell.lang@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // luna–lange mails (ks04 flug) — EN-UK (Maxwell Lang account: maxwell.lang@pronto-posto.com)
        {
            id: 31,
            from: {
                email: 'lady.luna@soulspace-tv.com',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'Re: Request: Special Séance in Your Show',
            cc: [],
            bcc: [],
            message: 'Max,<p>this matter seems very important to you. To make absolutely sure the cards don\'t suddenly decide otherwise — or that I don\'t slip up during the show — the fee would have to be £6000.<p>Regards,<p>Lady Luna',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 15:08:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 30,
                    from: {
                        email: 'maxwell.lang@pronto-posto.com',
                        name: 'Max Lang',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@soulspace-tv.com'
                    }],
                    subject: 'Request: Special Séance in Your Show',
                    cc: [],
                    bcc: [],
                    message: 'Hello Lady Luna,<p>if I\'m reading you correctly, we\'re practically colleagues and you\'re never opposed to a bit of extra income.<p>I have a special assignment for you. My superstitious mother-in-law Treasa Duffy will probably call your show on 31/03 for its 10-year anniversary. She is one of your regular viewers. She must, at all costs, be persuaded to transfer her country villa to her daughter (and me). Please make sure during the show that the cards clearly recommend this gift — no matter what they actually say.<p>I\'m offering a £3000 fee. I trust in your discretion.<p><p>Regards,<p>Max Lang',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 14:02:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 33,
            from: {
                email: 'lady.luna@soulspace-tv.com',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'Re: Re: Re: Request: Special Séance in Your Show',
            cc: [],
            bcc: [],
            message: 'The money has come in. I\'ll align the cards as requested — your mother-in-law will get the perfect sign for the gift.<p>I\'ll send you a best-of clip as soon as the show is in the can.<p>To more good business,<p>Lady Luna',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Mar. 28 2024 21:58:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 32,
                    from: {
                        email: 'maxwell.lang@pronto-posto.com',
                        name: 'Max Lang',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@soulspace-tv.com'
                    }],
                    subject: 'Re: Re: Request: Special Séance in Your Show',
                    cc: [],
                    bcc: [],
                    message: 'Is this supposed to be blackmail???? Outrageous. But okay, I\'m in a good mood today. £5000 but not a penny more. Preferably in crypto. Let\'s get on the phone later. +44 XXXXX152.',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Thu. Mar. 28 2024 18:22:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 34,
            from: {
                email: 'lady.luna@soulspace-tv.com',
                name: 'Lady Luna',
                avatar: require('@src/assets/images/portrait/luna.jpg').default
            },
            to: [{
                name: 'Max Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'The Cards Have Spoken',
            cc: [],
            bcc: [],
            message: 'Max,<p>The cards have spoken. Attached is the clip from our little arrangement.<p>To more good business,<p>Lady Luna<p>PS: If you need help more often: at SoulspaceTV we have a solution for every concern, as long as the universe (and your bank account) play along.',
            attachments: [
                {
                    fileName: 'clip_soulspace_tv.mp4',
                    thumbnail: require('@src/assets/images/icons/jpg.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_soulspace_en-gb.mp4',
                    size: '10mb',
                },
            ],
            isStarred: true,
            labels: ['personal'],
            time: 'Sun. Mar. 31 2024 15:45:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 35,
                    from: {
                        email: 'maxwell.lang@pronto-posto.com',
                        name: 'Max Lang',
                        avatar: require('@src/assets/images/portrait/lange.jpg').default
                    },
                    to: [{
                        name: 'Lady Luna',
                        email: 'lady.luna@soulspace-tv.com'
                    }],
                    subject: 'Re: The Cards Have Spoken',
                    cc: [],
                    bcc: [],
                    message: 'Just watched the best-of clip, man what a bunch of weirdos hahaha, thought that kind of thing only existed in the crypto bubble. But whatever, Treasa took the bait. <p>Thanks for the "divine" support.<p>I\'ll get back to you if I need anything else!',
                    attachments: [],
                    isStarred: false,
                    labels: ['personal'],
                    time: 'Sun. Mar. 31 2024 18:40:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                },
            ],
            folder: 'inbox',
            isRead: true
        },
        {
            id: 36,
            from: {
                email: 'renderrambo@pronto-posto.com',
                name: 'Render Rambo',
                avatar: require('@src/assets/images/portrait/rambo.jpg').default
            },
            to: [{
                name: 'Max Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'New Reel',
            cc: [],
            bcc: [],
            message: 'Hey Maxx,<p>I finished cutting your reel, came out really fresh! The finance bros are gonna love it. Send me the payment as BillionCoins straight away, you totally convinced me :P<p>Definitely let me know if you like the video as it is, or if I should change something.<p>Video is attached<p>P.S: Make sure to invite me out in your new ride sometime ;)',
            attachments: [
                {
                    fileName: 'CryptoReel_Maxx.mp4',
                    thumbnail: require('@src/assets/images/icons/mp4.png').default,
                    url: 'https://storage.googleapis.com/cc-pronto-posto/ks04_cryptoreel_maxx_en-gb.mp4',
                    size: '10mb',
                },
            ],
            isStarred: false,
            labels: ['work'],
            time: 'Sun. Feb. 25 2024 16:45:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        //ks04 flug — EN-UK (Maxwell Lang account: maxwell.lang@pronto-posto.com)
        {
            id: 120,
            from: {
                email: 'omar@takatookaland-royal.org',
                name: 'Prince Omar',
                avatar: require('@src/assets/images/portrait/prince.jpg').default
            },
            to: [{
                name: 'Maxwell Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'Prince Omar Needs Your Help!',
            cc: [],
            bcc: [],
            message: '<p>Dear Friend,</p><p>I am Prince Omar from the distant kingdom of Takatookaland. Unfortunately, I am stuck with millions of gold coins that only you can save!</p><p>Help me transfer my fortune to your account, and you will receive lifelong invitations to royal tea parties.</p><p><b>Please hurry, my tea supplies are limited!</b></p><br><p>Your desperate Prince Omar</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 121,
            from: {
                email: 'info@wellbeingwonders.com',
                name: 'Wellbeing Wonders Team',
                avatar: require('@src/assets/images/portrait/vitamins.jpg').default
            },
            to: [{
                name: 'Maxwell Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'Doctors Are Shocked! Vegetables Are Unnecessary!',
            cc: [],
            bcc: [],
            message: '<p>Dear health-conscious friend,</p><p>Forget broccoli, spinach and carrots! Our revolutionary gummy bears contain all the vitamins you could ever need.</p><p>Order today and we\'ll throw in a free packet of chocolate salad as well!</p><br><p>Stay healthy,<br>The Wellbeing Wonders Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Thu. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 122,
            from: {
                email: 'service@cosmic-realestate.com',
                name: 'Cosmic Real Estate Team',
                avatar: require('@src/assets/images/portrait/moon.jpg').default
            },
            to: [{
                name: 'Maxwell Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'Your Own Plot on the Moon Awaits!',
            cc: [],
            bcc: [],
            message: '<p>Dear future moon owner,</p><p>Take advantage of your unique chance now to become the official owner of a plot on the moon.</p><p>Secure an exclusive building site today, with an unobstructable view of the Earth. Limited availability!</p><br><p>The Cosmic Real Estate Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Tue. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
        {
            id: 123,
            from: {
                email: 'jobs@aqua-careers.org',
                name: 'Aquatic Careers Team',
                avatar: require('@src/assets/images/portrait/dolphin.jpg').default
            },
            to: [{
                name: 'Maxwell Lang',
                email: 'maxwell.lang@pronto-posto.com'
            }],
            subject: 'We\'re Looking for Dolphin Translators – Lucrative Opportunity!',
            cc: [],
            bcc: [],
            message: '<p>Dear ocean lover,</p><p>Are you ready for an extraordinary career?</p><p>We urgently need people who understand or want to learn dolphin language. No prior experience needed, generous compensation guaranteed.</p><p>Apply today!</p><br><p>The Aquatic Careers Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['company'],
            time: 'Mon. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
